import { SharedDocumalisModule } from '@documalis/shared-documalis.module';
import { NgModule } from '@angular/core';
import { EditorsRoutes } from './editors.routes';
import { ListEditorsComponent } from './list-editors/list-editors.component';
import { FormEditorsComponent } from './_components/form-editors/form-editors.component';
import { AddEditorsComponent } from './add-editors/add-editors.component';
import { EditEditorsComponent } from './edit-editors/edit-editors.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        EditorsRoutes,
        SharedDocumalisModule,
        TranslateModule
    ],
    declarations: [
        ListEditorsComponent,
        AddEditorsComponent,
        EditEditorsComponent,
        FormEditorsComponent,
    ]
})
export class EditorsModule { }
